"use strict";
exports.__esModule = true;
require('../impact/impact.component.css');
var angular = require("angular");
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
var ImpactComponent = /** @class */ (function () {
    function ImpactComponent($rootScope, $scope, $timeout) {
        this.values = [];
        this.dropZoneLength = 10;
        this.selectedIssue = null;
        this.selectedIssueCopy = null;
        this.stickyList = {};
        this.issueConfig = {};
        this.disableEdit = false;
        this.isOverflown = function (_a) {
            var clientHeight = _a.clientHeight, scrollHeight = _a.scrollHeight;
            return scrollHeight > clientHeight;
        };
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.DEFAULT);
        ctrl.utilsService.getValues();
        ctrl.$scope = $scope;
        ctrl.initValues(ctrl.values);
        ctrl.options = { show: true, id: -1 };
        ctrl.disableIt = false;
        // ctrl.boards = ['Impact Board', 'Calculated Impact Board'];
        // ctrl.selectedBoard = 'Impact Board';
        ctrl.$timeout = $timeout;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        ctrl.updateImpactTypeInSelected = function (inavImpactType) {
            $scope.$emit('updateImpactTypeInSelected', { inavImpactType: inavImpactType });
        };
        ctrl.initListeners();
        $timeout();
    }
    ImpactComponent.prototype.setIssueDetails = function (dropIndex, args) {
        var ctrl = this;
        ctrl.issueDetails = ctrl.getDataAndRemove(args.impact, args.id);
        ctrl.issueDetails.impact = dropIndex;
        ctrl.issueDetails.score = dropIndex * ctrl.issueDetails.ignorance;
        ctrl.issueDetails.updatedAt = ctrl.utilsService.updatedAt();
        ctrl.values[dropIndex].push(ctrl.issueDetails);
        // Update height after drag/drop
        ctrl.values.forEach(function (x) {
            x.forEach(function (y) {
                y.isHeightUpdated = false;
            });
        });
        ctrl.saveImpactBoard();
        ctrl.$scope.$apply();
    };
    ImpactComponent.prototype.initListeners = function () {
        var ctrl = this;
        ctrl.$scope.$on('command:IMPACT', function (event, args) {
            ctrl.disableEdit = (args.node.permissions == 'r');
            ctrl.initComponent(event, args);
        });
        ctrl.$scope.$on('CopiedFromAllStickies', function (event, args) {
            ctrl.copiedFromAllStickies = args.status;
        });
        var _loop_1 = function (dropIndex) {
            ctrl.$scope.$on('Drop' + dropIndex, function (event, args) {
                ctrl.setIssueDetails(dropIndex, args);
            });
        };
        for (var dropIndex = 0; dropIndex < ctrl.dropZoneLength; dropIndex++) {
            _loop_1(dropIndex);
        }
    };
    ImpactComponent.prototype.initValues = function (values) {
        var ctrl = this;
        for (var index = 0; index < ctrl.dropZoneLength; index++) {
            values[index] = [];
        }
    };
    ImpactComponent.prototype.onSelectSticky = function (sticky, index) {
        var ctrl = this;
        ctrl.selectedIssueCopy = JSON.parse(JSON.stringify(sticky));
        ctrl.selectedIssue = sticky;
        ctrl.selectedIssue.index = index;
    };
    ImpactComponent.prototype.onSetStickyHeight = function (id) {
        var element = document.getElementById(id);
        element.style.height = "1px";
        element.style.height = element.scrollHeight + 5 + "px";
    };
    ImpactComponent.prototype.onSaveSticky = function () {
        var ctrl = this;
        // const id = ctrl.selectedIssue._id;
        // const index = ctrl.selectedIssue.index;
        // ctrl.items[ctrl.selectedIssue.ignorance][index] = ctrl.selectedIssue;
        // ctrl.updateIgGrid(id, index);
        // const issueData = ctrl.removeAndReturnChangedIgnorance(id);
        // ctrl.items[index].push(issueData);
        ctrl.saveImpactBoard();
        ctrl.selectedIssue = null;
        // ctrl.$scope.$apply();
    };
    ImpactComponent.prototype.onCloseStickyModal = function () {
        var ctrl = this;
        ctrl.values[ctrl.isQualitative ? ctrl.selectedIssue.impact : ctrl.selectedIssue.calcImpact][ctrl.selectedIssue.index] =
            JSON.parse(JSON.stringify(ctrl.selectedIssueCopy));
        // ctrl.selectedIssueList[ctrl.selectedIssue.index] = JSON.parse(JSON.stringify(ctrl.selectedIssueCopy));
        ctrl.selectedIssue = null;
    };
    ImpactComponent.prototype.deleteNode = function () {
        var ctrl = this;
        bootbox.dialog({
            message: "You are about to delete this issue. Are you sure?",
            title: "Confirm Deletion",
            buttons: {
                confirm: {
                    label: "Delete",
                    className: "btn-danger",
                    callback: function () {
                        ctrl.deleteSticky();
                    }
                },
                cancel: {
                    label: "Cancel",
                    className: "btn-primary"
                }
            }
        });
    };
    ;
    ImpactComponent.prototype.deleteSticky = function () {
        var ctrl = this;
        ctrl.values[ctrl.isQualitative ? ctrl.selectedIssue.impact : ctrl.selectedIssue.calcImpact].splice(ctrl.selectedIssue.index, 1);
        ctrl.saveImpactBoard();
        ctrl.selectedIssue = null;
    };
    ImpactComponent.prototype.resetAllStickies = function () {
        var ctrl = this;
        ctrl.allStickies = [];
    };
    ImpactComponent.prototype.getDataAndRemove = function (impact, id) {
        var ctrl = this;
        var data = ctrl.values[impact][id];
        ctrl.removeIssueByIndex(ctrl.values[impact], id);
        return data;
    };
    ImpactComponent.prototype.updateChangeDate = function (impact, id) {
        var ctrl = this;
        var index = +impact.split(/\D+/)[1];
        ctrl.values[index][id].updatedAt = ctrl.utilsService.updatedAt();
    };
    ImpactComponent.prototype.getDFVSWOTData = function () {
        var ctrl = this;
        ctrl.emptyAll();
        ctrl.smartorg.getDFVAndSWOTData(ctrl.node._id).then(function (res) {
            ctrl.$scope.$emit('workbench:loading', { 'load': false });
            if (res) {
                ctrl.initDFVAndSWOTData(res);
                ctrl.$timeout();
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
                ctrl.saving = false;
            }
        })["catch"](function (err) {
            ctrl.$scope.$emit('workbench:loading', { 'load': false });
            ctrl.showAlert('danger', 'Error!', err.message);
            ctrl.saving = false;
        });
        // if(ctrl.isQualitative){
        //     ctrl.smartorg.getDFVAndSWOTData(ctrl.node._id).then((res) => {
        //         if (res) {
        //             ctrl.initDFVAndSWOTData(res);
        //             ctrl.$timeout();
        //             ctrl.$scope.$apply();
        //         } else {
        //             ctrl.showAlert('danger', 'Error!', res.message);
        //             ctrl.saving = false;
        //         }
        //     }).catch((err) => {
        //         ctrl.showAlert('danger', 'Error!', err.message);
        //         ctrl.saving = false;
        //     });
        //
        // } else{
        //     ctrl.getDFVData();
        //     ctrl.disableIt = false;
        // }
    };
    ImpactComponent.prototype.switchImpactBoardType = function () {
        var ctrl = this;
        ctrl.disableIt = !ctrl.isQualitative;
        var issues = [].concat.apply([], ctrl.values);
        if (issues.length > 0) {
            var newValues_1 = [];
            ctrl.initValues(newValues_1);
            issues.map(function (issue) {
                if (ctrl.isQualitative) {
                    newValues_1[issue.impact].push(issue);
                }
                else {
                    newValues_1[issue.calcImpact].push(issue);
                }
            });
            ctrl.values = newValues_1;
        }
    };
    ImpactComponent.prototype.showIssueInfo = function (issueId) {
        var ctrl = this;
        bootbox.dialog({
            message: "Node Id: " + ctrl.node._id + " <br> Issue Id: " + issueId,
            title: "Issue Info",
            buttons: {
                cancel: {
                    label: "Cancel",
                    className: "btn-primary"
                }
            }
        });
    };
    ImpactComponent.prototype.initDFVAndSWOTData = function (res) {
        var ctrl = this;
        ctrl.issueConfig = ctrl.utilsService.getIssueConfig(res['CanvasConfig']);
        ctrl.stickyList = res['NColCanvasSwotData'];
        // Use the shared utility method to determine mode and toggle visibility
        var modeConfig = ctrl.utilsService.determineQualitativeMode(res, ctrl.node);
        ctrl.isQualitative = modeConfig.isQualitative;
        // Setup the toggle based on configuration
        if (modeConfig.showToggle) {
            setTimeout(function () {
                ctrl.menu = [{
                        'status': ctrl.isQualitative,
                        'onLabel': 'Qualitative',
                        'offLabel': 'Quantitative',
                        'showToggle': function () {
                            return true;
                        },
                        'callback': function () {
                            ctrl.changeImpactType();
                        }
                    }];
            }, 0);
        }
        else {
            ctrl.menu = [];
        }
        // Set the board type based on the determined mode
        ctrl.impactBoardType = ctrl.isQualitative ? 'Qualitative' : 'Quantitative';
        var indexToRemove = [];
        ctrl.switchImpactBoardType();
        // ctrl.disableIt = true;
        // convert objects into array of arrays then flat it to single array
        ctrl.allStickies = [].concat.apply([], Object.values(ctrl.stickyList));
        ctrl.allStickies.map(function (k, i) {
            k['title'] = ctrl.utilsService.returnLimitedTitle(k);
            k['color'] = ctrl.issueConfig[k.type];
            if (ctrl.isQualitative) {
                ctrl.values[k.impact].push(k);
            }
            else {
                if (k.calcImpact == null) {
                    k.calcImpact = 0;
                }
                ctrl.values[k.calcImpact].push(k);
            }
            indexToRemove.push(i);
        });
        indexToRemove.sort(function (a, b) {
            return b - a;
        });
        indexToRemove.map(function (item) {
            ctrl.allStickies.splice(item, 1);
        });
    };
    ImpactComponent.prototype.setStickyHeight = function (id, stickyIndex, node) {
        console.log(id + ' : ' + stickyIndex + " : ");
        var ctrl = this;
        if (!node.isHeightUpdated) {
            ctrl.setFontSize(id, stickyIndex);
            node.isHeightUpdated = true;
        }
    };
    ImpactComponent.prototype.setFontSize = function (id, stickyIndex) {
        var ctrl = this;
        var stickyID = id + stickyIndex;
        var element = document.getElementById(stickyID);
        if (element != null) {
            ctrl.updateStickyHeight(element);
        }
    };
    ImpactComponent.prototype.updateStickyHeight = function (element) {
        element.style.height = "1px";
        element.style.height = (3 + element.scrollHeight) + "px"; // 3 px for padding so 5px for adjustments
        var targetParentBlock = element.parentElement.parentElement.parentElement.parentElement;
        if (targetParentBlock.classList.contains("centerItems")) {
            targetParentBlock.style.height = "1px";
            targetParentBlock.style.height = (56 + element.scrollHeight) + "px";
        }
    };
    ImpactComponent.prototype.showNoteDialog = function () {
        console.log('showNoteDialog');
    };
    ImpactComponent.prototype.changedNote = function (note) {
        note.isHeightUpdated = false;
    };
    // getFontSize(id, stickyIndex) {
    //     const ctrl = this;
    //     let stickyID = id + stickyIndex;
    //     let element = document.getElementById(stickyID);
    //     let i = 14;
    //     const minSize = 12;
    //     if (!ctrl.isOverflown(element)) {
    //         element.style.fontSize = "14px";
    //     }
    //     else if (ctrl.isOverflown(element) && i > minSize) {
    //         i -= 2;
    //         element.style.fontSize = `${i}px`;
    //     }
    // }
    ImpactComponent.prototype.onStickyChange = function (id, stickyIndex) {
        var ctrl = this;
        ctrl.updateChangeDate(id, stickyIndex);
        ctrl.setFontSize(id, stickyIndex);
        ctrl.saveImpactBoard();
    };
    ImpactComponent.prototype.removeIssueByIndex = function (array, index) {
        if (index > -1) {
            array.splice(index, 1);
        }
    };
    ImpactComponent.validateStr = function (stringToValidate) {
        var regExp = /[a-zA-Z0-9]/g;
        return regExp.test(stringToValidate);
    };
    ;
    // addSticky() {
    //     const ctrl = this;
    //     ctrl.values[0].unshift(
    //         ctrl.utilsService.getNewSticky(),
    //     );
    //     ctrl.saveImpactBoard();
    // }
    //
    // deleteSticky(issueId, list) {
    //     const ctrl = this;
    //     for (let i = 0; i < list.length; i++) {
    //         if (issueId == list[i]._id) {
    //             list.splice(i, 1);
    //             break;
    //         }
    //     }
    //     ctrl.saveImpactBoard();
    // }
    ImpactComponent.prototype.setHoveredSticky = function (show, id) {
        var ctrl = this;
        ctrl.options = { show: true, id: id };
    };
    ImpactComponent.prototype.showIcons = function (id) {
        var ctrl = this;
        return ctrl.options.show == true && ctrl.options.id == id;
    };
    ImpactComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem;
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        ctrl.isQualitative = false;
        ctrl.impactBoardType = 'Quantitative';
        // Initialize menu as empty - it will be populated in initDFVAndSWOTData based on configuration
        ctrl.menu = [];
        ctrl.emptyAll();
        ctrl.getDFVSWOTData();
    };
    ImpactComponent.prototype.emptyAll = function () {
        var ctrl = this;
        ctrl.allStickies = [];
        ctrl.initValues(ctrl.values);
    };
    ImpactComponent.prototype.changeImpactType = function () {
        var ctrl = this;
        ctrl.isQualitative = !ctrl.isQualitative;
        ctrl.switchImpactBoardType();
        ctrl.impactBoardType = ctrl.isQualitative ? 'Qualitative' : 'Quantitative';
        // Update height after drag/drop
        ctrl.values.forEach(function (x) {
            x.forEach(function (y) {
                y.isHeightUpdated = false;
            });
        });
        // Save the user's preference to the node
        ctrl.node['inavImpactType'] = ctrl.impactBoardType;
        ctrl.smartorg.saveInavImpactType(ctrl.node._id, ctrl.impactBoardType).then(function (res) {
            if (res) {
                ctrl.updateImpactTypeInSelected(ctrl.impactBoardType);
                ctrl.showAlert('success', 'Saved!', 'Impact type changed successfully.');
                ctrl.$timeout();
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
                ctrl.saving = false;
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
            ctrl.saving = false;
        });
    };
    ImpactComponent.prototype.saveImpactBoard = function () {
        var ctrl = this;
        var res = [].concat.apply([], ctrl.values);
        var req = {};
        res.forEach(function (x) {
            // init if array not exist
            if (!req[x.type])
                req[x.type] = [];
            req[x.type].push(x);
        });
        ctrl.$timeout(function () {
            ctrl.smartorg.saveDFVAndSWOTData(ctrl.node._id, req).then(function (ret) {
                if ('data' in ret) {
                    // returns data if new sticky is created.
                    var res_1 = ret['data'];
                    ctrl.emptyAll();
                    ctrl.initDFVAndSWOTData(res_1);
                    ctrl.saving = false;
                    ctrl.$timeout();
                    ctrl.$scope.$apply();
                }
                else {
                    ctrl.saving = false;
                }
            })["catch"](function (err) {
                ctrl.showAlert('danger', 'Error!', err.message);
                ctrl.saving = false;
            });
        }, 500);
    };
    return ImpactComponent;
}());
function getDropDetails(ev) {
    ev.preventDefault();
    var data = ev.originalEvent.dataTransfer.getData('text/plain');
    var draggable = document.getElementById(data);
    var textarea = draggable.getElementsByTagName('span');
    var nameGot = textarea[0].innerHTML;
    var id = parseInt(data.split(":")[1]);
    var impact = parseInt(data.split(":")[2]);
    return { draggable: draggable, nameGot: nameGot, id: id, impact: impact };
}
angular.module('smartorg.r6.acts.impact', []).component('impact', {
    template: require('./impact.component.html'),
    controller: ImpactComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
})
    .directive('noteImpactContent', function () {
    return {
        restrict: 'E',
        link: function (scope, element, attrs) {
            element.bind('click', function () {
                scope.contenteditable = true;
            });
        }
    };
})
    .directive('noteImpact', function ($document) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: '<div class="note"><div class="noteBody" ng-transclude></div></div>',
        link: function (scope, element, attr) {
            element.on('dragstart', function (ev) {
                ev.originalEvent.dataTransfer.setData('text/plain', ev.target.id);
                setTimeout(function () {
                    // document.getElementById(ev.target.id).style.display='none'
                }, 0);
                if (ev.target.id.indexOf('sticky') !== -1) {
                    scope.$emit('CopiedFromAllStickies', { 'status': true, id: ev.target.id });
                }
                else {
                    scope.$emit('CopiedFromAllStickies', { 'status': false });
                }
                scope.$apply();
            });
        }
    };
})
    .directive('dragDropAllStickies', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), draggable = _a.draggable, nameGot = _a.nameGot, id = _a.id, impact = _a.impact;
                scope.$emit('Drop0', { 'issue': nameGot, 'type': draggable.getAttribute("name"), id: id, impact: impact });
            });
        }
    };
})
    .directive('dragDrop1', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), draggable = _a.draggable, nameGot = _a.nameGot, id = _a.id, impact = _a.impact;
                scope.$emit('Drop1', { 'issue': nameGot, 'type': draggable.getAttribute("name"), id: id, impact: impact });
            });
        }
    };
})
    .directive('dragDrop2', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), draggable = _a.draggable, nameGot = _a.nameGot, id = _a.id, impact = _a.impact;
                scope.$emit('Drop2', { 'issue': nameGot, 'type': draggable.getAttribute("name"), id: id, impact: impact });
            });
        }
    };
})
    .directive('dragDrop3', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), draggable = _a.draggable, nameGot = _a.nameGot, id = _a.id, impact = _a.impact;
                scope.$emit('Drop3', { 'issue': nameGot, 'type': draggable.getAttribute("name"), id: id, impact: impact });
            });
        }
    };
})
    .directive('dragDrop4', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), draggable = _a.draggable, nameGot = _a.nameGot, id = _a.id, impact = _a.impact;
                scope.$emit('Drop4', { 'issue': nameGot, 'type': draggable.getAttribute("name"), id: id, impact: impact });
            });
        }
    };
})
    .directive('dragDrop5', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), draggable = _a.draggable, nameGot = _a.nameGot, id = _a.id, impact = _a.impact;
                scope.$emit('Drop5', { 'issue': nameGot, 'type': draggable.getAttribute("name"), id: id, impact: impact });
            });
        }
    };
})
    .directive('dragDrop6', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), draggable = _a.draggable, nameGot = _a.nameGot, id = _a.id, impact = _a.impact;
                scope.$emit('Drop6', { 'issue': nameGot, 'type': draggable.getAttribute("name"), id: id, impact: impact });
            });
        }
    };
})
    .directive('dragDrop7', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), draggable = _a.draggable, nameGot = _a.nameGot, id = _a.id, impact = _a.impact;
                scope.$emit('Drop7', { 'issue': nameGot, 'type': draggable.getAttribute("name"), id: id, impact: impact });
            });
        }
    };
})
    .directive('dragDrop8', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), draggable = _a.draggable, nameGot = _a.nameGot, id = _a.id, impact = _a.impact;
                scope.$emit('Drop8', { 'issue': nameGot, 'type': draggable.getAttribute("name"), id: id, impact: impact });
            });
        }
    };
})
    .directive('dragDrop9', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), draggable = _a.draggable, nameGot = _a.nameGot, id = _a.id, impact = _a.impact;
                scope.$emit('Drop9', { 'issue': nameGot, 'type': draggable.getAttribute("name"), id: id, impact: impact });
            });
        }
    };
});
module.exports = 'smartorg.r6.acts.impact';
////// 841+ lines
//# sourceMappingURL=impact.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/impact/impact.component.js